import { RefObject, useEffect } from "react";

function useResizeElement<T extends HTMLElement>(
  ref: RefObject<T>,
  onResize?: (width: number, height: number) => void,
  interval = 500
) {
  useEffect(() => {
    if (!ref.current) return;

    let width = ref.current.clientWidth;
    let height = ref.current.clientHeight;
    const iId = setInterval(() => {
      if (!ref.current) return;
      const { clientWidth, clientHeight } = ref.current;

      if (width !== clientWidth || height !== clientHeight) {
        width = clientWidth;
        height = clientHeight;
        if (onResize) onResize(width, height);
      }
    }, interval);

    return () => clearInterval(iId);
  }, [ref, onResize, interval]);
}

export default useResizeElement;
